import { render } from "./AccountDelegue.vue?vue&type=template&id=74fccc8a&scoped=true"
import script from "./AccountDelegue.vue?vue&type=script&lang=js"
export * from "./AccountDelegue.vue?vue&type=script&lang=js"

import "./AccountDelegue.vue?vue&type=style&index=0&id=74fccc8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fccc8a"]])

export default __exports__